import { RANGER_LEVELS } from './data/levels/level-01';
import { getMissionTargets } from './rangerProgression';

const missionTargets = getMissionTargets(RANGER_LEVELS);

export const RANGER_MISSIONS = RANGER_LEVELS.map(({ id, name, objectiveText }, index) => ({
  id,
  name,
  objectiveText,
  target: missionTargets[index],
}));

export const rangerDefinition = {
  id: 'ranger',
  name: 'Ranger',
  shortName: 'Ranger',
  summary: 'Ten top-down field missions with patrols, rescue, sabotage, escape, and flag capture.',
  instructions: 'Move with arrows, WASD, or touch. Avoid patrols and complete each mission objective.',
  playfieldLabel: 'Ranger playfield',
  storageNamespace: 'ranger',
  themeClass: 'theme-ranger',
  missions: RANGER_MISSIONS,
};
